<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Código del Periodo">
        <b-form-input
          v-model="form.codigo"
          placeholder="Ej: PER-2024-01"
          required
        />
      </b-form-group>
      <b-form-group label="Año" class="mt-1">
        <b-form-input
          v-model.number="form.año"
          type="number"
          placeholder="Ej: 2024"
          required
        />
      </b-form-group>
      <b-form-group label="Ciclo" class="mt-1">
        <b-form-select
          v-model="form.ciclo"
          :options="cycleOptions"
          required
        />
      </b-form-group>
      <b-form-group label="Fecha de Inicio" class="mt-1">
        <b-form-datepicker
          v-model="form.fechaInicio"
          required
        />
      </b-form-group>
      <b-form-group label="Fecha de Fin" class="mt-1">
        <b-form-datepicker
          v-model="form.fechaFin"
          required
        />
      </b-form-group>
      <b-form-group label="Estado" class="mt-1">
        <b-form-select
          v-model="form.estado"
          :options="statusOptions"
          required
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormDatepicker } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
  },
  props: {
    periodData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalId: 'period-modal',
      form: {
        periodoId: null,
        codigo: '',
        año: new Date().getFullYear(),
        ciclo: 1,
        fechaInicio: '',
        fechaFin: '',
        estado: true,
      },
      cycleOptions: [
        { value: 1, text: 'Primer Ciclo' },
        { value: 2, text: 'Segundo Ciclo' },
        { value: 3, text: 'Interciclo' },
      ],
      statusOptions: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false }
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.periodoId ? 'Editar Periodo' : 'Nuevo Periodo'
    },
  },
  watch: {
    periodData(newData) {
      if (newData) {
        this.form = { ...newData }
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    handleSubmit() {
      // Validar que se hayan completado todos los campos requeridos
      if (!this.form.codigo || !this.form.año || !this.form.ciclo || !this.form.fechaInicio || !this.form.fechaFin) {
        this.$bvToast.toast('Debe completar todos los campos requeridos', {
          title: 'Error de Validación',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000,
        })
        return
      }

      // Preparar los datos para envío
      const formData = {
        codigo: this.form.codigo.trim(),
        año: parseInt(this.form.año),
        ciclo: parseInt(this.form.ciclo),
        fechaInicio: this.form.fechaInicio,
        fechaFin: this.form.fechaFin,
        estado: this.form.estado,
      }

      // Si es edición, incluir el ID
      if (this.form.periodoId) {
        formData.periodoId = this.form.periodoId
      }

      console.log('Datos del período a enviar:', formData)
      this.$emit('submit', formData)
      this.$bvModal.hide(this.modalId)
    },
    resetForm() {
      this.form = {
        periodoId: null,
        codigo: '',
        año: new Date().getFullYear(),
        ciclo: 1,
        fechaInicio: '',
        fechaFin: '',
        estado: true,
      }
    },
  },
}
</script>
